export default __webpack_public_path__ + "static/media/greenShopifyLogo.4219098f.svg";